export default __webpack_public_path__ + "static/media/reporticon.5879f33a.png";